import { render, staticRenderFns } from "./Pefe.vue?vue&type=template&id=6db14d56&lang=true"
import script from "./Pefe.vue?vue&type=script&lang=js"
export * from "./Pefe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports